import { Pipe, PipeTransform } from '@angular/core';
import { map, trim } from 'lodash';

@Pipe({
  name: 'pluralizedList',
  standalone: true,
})
export class PluralizedListPipe implements PipeTransform {
  transform(values: string[], conjunction = $localize`and`): string {
    if (values === null || values === undefined) {
      throw new TypeError(
        `Wrong value for PluralizedListPipe provided: ${values} is not an array`
      );
    }

    if (conjunction === null || conjunction === '') {
      throw new TypeError(
        `Wrong conjunction for PluralizedListPipe provided: ${conjunction} is not a word`
      );
    }

    const trimmedValues = map(values, trim);

    if (trimmedValues.length < 2) {
      return trimmedValues[0] || '';
    }

    if (trimmedValues.length === 2) {
      return `${trimmedValues[0]} ${trim(conjunction)} ${trimmedValues[1]}`;
    }

    let result = '';
    for (let i = 0; i < trimmedValues.length - 1; i++) {
      result += `${trim(trimmedValues[i])}, `;
    }
    result += `${trim(conjunction)} ${trim(
      trimmedValues[trimmedValues.length - 1]
    )}`;
    return result;
  }
}
